import { JSONSchemaType } from 'ajv'

export interface IQbemApiConfigForm {
  email: string
  senha: string
  idEstipulante: string
  subestipulante: string
  baseUrl: string
  autoConfirmar: boolean
  enableChangeMovements: boolean
}

const QbemApiConfigSchema: JSONSchemaType<IQbemApiConfigForm> = {
  type: 'object',
  properties: {
    email: {
      type: 'string',
      minLength: 1,
      errorMessage: 'Email é obrigatório.',
    },
    senha: {
      type: 'string',
      minLength: 1,
      errorMessage: 'Senha é obrigatória.',
    },
    idEstipulante: {
      type: 'string',
      minLength: 1,
      errorMessage: 'ID do Estipulante é obrigatório.',
    },
    subestipulante: {
      type: 'string',
      minLength: 1,
      errorMessage: 'Subestipulante é obrigatório.',
    },
    // Optional. The form posts `baseUrl: baseUrl || undefined`, and the backend
    // falls back to "https://eb.qbem.net.br" when absent — keeping it required
    // would only block submissions while permitting an empty string (no minLength).
    baseUrl: {
      type: 'string',
    },
    autoConfirmar: {
      type: 'boolean',
    },
    enableChangeMovements: {
      type: 'boolean',
    },
  },
  required: ['email', 'senha', 'idEstipulante', 'subestipulante', 'autoConfirmar', 'enableChangeMovements'],
  additionalProperties: false,
}

export default QbemApiConfigSchema
